export const paths = {
  SETTING: 'setting',
}

export const preferencesLinks = {
  preferredSettingsLink: (params: { addressId: string }) => `/${paths.SETTING}/${params.addressId}`,
}

export type PreferencesLinks = typeof preferencesLinks
